import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">联系我们</h2>
        </div>

        <div className="bg-gradient-to-r from-accent-50/60 via-background-50 to-primary-50/40 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-10">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-3">
                有建议或合作意向？欢迎联系
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                {contactInfo.description}
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-mail-line"></i>
                  </span>
                  <span className="font-medium">{contactInfo.email}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-wechat-line"></i>
                  </span>
                  <span className="font-medium">{contactInfo.wechat}</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 w-full max-w-xs">
              <div className="aspect-square bg-background-100 rounded-2xl flex items-center justify-center border border-background-200/70">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-500">
                    <i className="ri-chat-smile-2-line text-3xl"></i>
                  </div>
                  <p className="text-sm text-foreground-400 mt-3">扫码添加微信</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}